import type domainsEn from "./domains.en";

const domainsAr: Record<keyof typeof domainsEn, string> = {
  "settings.domains": "النطاقات",
  "settings.domains_hint": "عنوان متجرك والنطاقات المرتبطة",

  "domains.title": "النطاقات",
  "domains.connect": "ربط نطاق موجود",
  "domains.hint": "يصل الزوار إلى متجرك عبر نطاقه الأساسي، وتُحوَّل النطاقات الأخرى إليه.",
  "domains.primary": "أساسي",
  "domains.platform": "عنوان المتجر",
  "domains.custom": "نطاق مرتبط",
  "domains.status.connected": "مرتبط",
  "domains.status.pending": "بانتظار التحقق",
  "domains.status.ssl_pending": "شهادة SSL قيد الإصدار",
  "domains.status.misconfigured": "يحتاج إلى مراجعة",
  "domains.status.proxied": "يمر عبر Cloudflare",
  "domains.status.disconnected": "مفصول",
  "domains.status.redirect_only": "يُحوِّل حتى {date}",
  "domains.redirects": "يُحوِّل إلى {host}",
  "domains.no_redirect": "يعرض متجرك دون تحويل",
  "domains.make_primary": "تعيين كأساسي",
  "domains.make_primary_title": "جعل {host} النطاق الأساسي؟",
  "domains.make_primary_body": "سيُوجَّه الزوار ومحركات البحث إلى {host}، وستُحوَّل نطاقاتك الأخرى إليه (301) مع الحفاظ على الصفحة المطلوبة.",
  "domains.redirect_on": "التحويل إلى الأساسي",
  "domains.redirect_off": "إيقاف التحويل",
  "domains.dns": "إعدادات DNS",
  "domains.remove": "إزالة",
  "domains.remove_title": "إزالة {host}؟",
  "domains.remove_body": "لن يكون متجرك متاحاً عبر هذا النطاق بعد الآن.",
  "domains.removed": "تمت إزالة النطاق",
  "domains.primary_set": "أصبح {host} نطاقك الأساسي",
  "domains.change_address": "تغيير عنوان المتجر",
  "domains.change_title": "تغيير عنوان متجرك",
  "domains.change_hint": "يمكنك تغييره مرة كل 30 يوماً. يستمر العنوان القديم في التحويل إلى متجرك لمدة 90 يوماً.",
  "domains.new_address": "العنوان الجديد",
  "domains.changed": "أصبح عنوان متجرك {host}",

  "connect.title": "ربط نطاق موجود",
  "connect.domain": "النطاق",
  "connect.domain_hint": "مثال: example.com. سنربط www.example.com أيضاً.",
  "connect.next": "التالي",
  "connect.records_title": "حدّث سجلات DNS",
  "connect.records_hint": "سجّل الدخول لدى الشركة التي اشتريت منها النطاق (GoDaddy أو Namecheap أو Cloudflare أو مسجّل نطاقات ‎.qa…)، وافتح إعدادات DNS وأضف هذه السجلات. قد تستغرق التغييرات حتى 48 ساعة.",
  "connect.type": "النوع",
  "connect.name": "الاسم",
  "connect.value": "القيمة",
  "connect.current": "الحالي",
  "connect.nothing": "لا شيء بعد",
  "connect.verify": "تحقق الآن",
  "connect.checking": "نتحقق تلقائياً كل بضع دقائق. يمكنك إغلاق هذه النافذة.",
  "connect.done": "تم",
  "connect.copied": "تم النسخ",
  "connect.txt_note": "هذا النطاق مرتبط بمتجر آخر. يثبت سجل TXT ملكيتك له.",
  "connect.cloudflare": "تستخدم Cloudflare؟ اجعل هذه السجلات «DNS only» (السحابة الرمادية).",
};

export default domainsAr;
